import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services';
import { takeUntil } from 'rxjs/operators';
import { forEach } from 'lodash';
import { GetImageSrcPipe } from 'app/pipes/get-image-src.pipe';
import { AttachmentsService } from 'app/services/attachments.service';
import { Subject } from 'rxjs';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'properties-details-view',
  templateUrl: './properties-details-view.component.html',
  styleUrls: ['./properties-details-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [GetImageSrcPipe]
})
export class PropertiesDetailsViewComponent implements OnInit {

  currentAgency: any;
  currentLang: string;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private _authenticationService: AuthenticationService,
    public matDialogRef: MatDialogRef<PropertiesDetailsViewComponent>,
    private _getImageSrcPipe: GetImageSrcPipe,
    private _attachmentsService: AttachmentsService,
    private _translateService: TranslateService,
    private _lightbox: Lightbox,
    @Inject(MAT_DIALOG_DATA) public property: any
  ) {
    this.currentLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
    this.currentAgency = this._authenticationService.currentAgencyValue;
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this._attachmentsService.getModelAttachments(this.property._id, 'properties_images')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: any) => {
        this.property.images = data;
        this.property._albums = [];
        forEach(data, (model: any) => {
          const album = {
            src: this._getImageSrcPipe.transform(model)
          };
          this.property._albums.push(album);
        });
      });
  }
  openLightbox(_albums: any, index: any): void {
    this._lightbox.open(_albums, index);
  }

}
